import UserEvent from "../../core/UserEvent";
import Box from "../Box";
import {Typography} from "@material-ui/core";
import React, {useEffect} from "react";
import logger from "../../core/logger";
import MCQuestion from "./MCQuestion";
import SCQuestion from "./SCQuestion";
import OEQuestion from "./OEQuestion";
import YNQuestion from "./YNQuestion";
import {Question} from "../../qnr/Questionnaire";
import lang from "../../core/lang";
import PropTypes from "prop-types";
import {Questionnaire} from "../../qnr";

const log = logger.getLogger('appfuse.component.Survey.Section');

const ROMAN_NUM = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

function Section(props) {

    const {value, change, index, compact, readOnly, disabled, validation, disabledColor, diff, showUndo, variant, changeIndicator, tailIndicatorRenderer} = props;
    const section = change ? change : value;
    const {subject, description} = section;

    const handleChange = index => event => {
        const { value } = event;
        const question = value;
        const newSection = section.clone();
        newSection.setQuestion(index, question, true);
        props.onChange && props.onChange(new UserEvent({
            value: newSection,
            change: newSection,
            section: newSection,
            question
        }));
    }

    const questions = value.getQuestions(true).map((question, index) => {
        const {type} = question;
        const questionChange = change?.getQuestions(true)[index];
        if(type===Question.Type.MCQ) {
            return (
              <MCQuestion
                key={index}
                index={index}
                value={question}
                change={questionChange}
                diff={diff}
                showUndo={showUndo}
                variant={variant}
                onChange={handleChange(index)}
                readOnly={readOnly}
                disabled={disabled}
                validation={validation}
                disabledColor={disabledColor}
                changeIndicator={changeIndicator}
                tailIndicatorRenderer={tailIndicatorRenderer}
              />
            );
        } else if(type===Question.Type.SCQ) {
            return (
              <SCQuestion
                key={index}
                index={index}
                value={question}
                change={questionChange}
                diff={diff}
                showUndo={showUndo}
                variant={variant}
                onChange={handleChange(index)}
                readOnly={readOnly}
                disabled={disabled}
                validation={validation}
                disabledColor={disabledColor}
                changeIndicator={changeIndicator}
                tailIndicatorRenderer={tailIndicatorRenderer}
              />
            );
        } else if(type===Question.Type.OEQ) {
            return (
              <OEQuestion
                key={index}
                index={index}
                value={question}
                change={questionChange}
                diff={diff}
                showUndo={showUndo}
                variant={variant}
                onChange={handleChange(index)}
                readOnly={readOnly}
                disabled={disabled}
                validation={validation}
                disabledColor={disabledColor}
                changeIndicator={changeIndicator}
                tailIndicatorRenderer={tailIndicatorRenderer}
              />
            );
        } else if(type===Question.Type.YNQ) {
            return (
              <YNQuestion
                key={index}
                index={index}
                value={question}
                change={questionChange}
                diff={diff}
                showUndo={showUndo}
                variant={variant}
                onChange={handleChange(index)}
                readOnly={readOnly}
                disabled={disabled}
                validation={validation}
                disabledColor={disabledColor}
                changeIndicator={changeIndicator}
                tailIndicatorRenderer={tailIndicatorRenderer}
              />
            );
        } else {
            log.warn(`Unsupported question type: ${type}. supported question type: mcq, scq, oeq & ynq. Question: ${question.description}`)
            if(lang.isNotEmpty(question.options)) {
                return (
                  <SCQuestion
                    key={index}
                    index={index}
                    value={question}
                    variant={variant}
                    change={questionChange}
                    diff={diff}
                    showUndo={showUndo}
                    onChange={handleChange(index)}
                    readOnly={readOnly}
                    disabled={disabled}
                    validation={validation}
                    disabledColor={disabledColor}
                    changeIndicator={changeIndicator}
                    tailIndicatorRenderer={tailIndicatorRenderer}
                  />
                );
            } else {
                return (
                  <OEQuestion
                    key={index}
                    index={index}
                    value={question}
                    variant={variant}
                    change={questionChange}
                    diff={diff}
                    showUndo={showUndo}
                    onChange={handleChange(index)}
                    readOnly={readOnly}
                    disabled={disabled}
                    validation={validation}
                    disabledColor={disabledColor}
                    changeIndicator={changeIndicator}
                    tailIndicatorRenderer={tailIndicatorRenderer}
                  />
                );
            }
        }
    });

    const romanIndex = ROMAN_NUM[index];

    log.debug('Rendered.');

    return (
        // overflow = hidden 避免欄位的中文標籤過長時, 會造成內容比實際長度更長, 出現不正常的捲動.
        <Box display="flex" flexDirection="column" gap={1} overflow="hidden" >
            {compact ? null : <Typography variant="h6">{`${romanIndex}. ${subject}`}</Typography>}
            {compact ? null : <Typography>{description}</Typography>}
            <Box display="flex" flexDirection="column" gap={1} marginTop={1}>
                {questions}
            </Box>
        </Box>
    )
}

Section.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.instanceOf(Questionnaire.Section)
    ]),
    change: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.instanceOf(Questionnaire)
    ]),
    index: PropTypes.number,
    onChange: PropTypes.func,
    compact: PropTypes.bool,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    // 是否檢視檢核結果
    validation: PropTypes.bool,
    disabledColor: PropTypes.string,
    // 標示變更的差異
    diff: PropTypes.bool,
    showUndo: PropTypes.bool,
    variant: PropTypes.oneOf(['legacy', 'classic']),
    changeIndicator: PropTypes.func,
    tailIndicatorRenderer: PropTypes.func,
}

Section.defaultProps = {
    variant: 'classic',
    showUndo: true,
}

export default Section;